<template>
    <main-layout>
        <div id="app">
            <div class="container">
                <h1>404</h1>
                <!--            <v-link href="/">Home</v-link>-->
            </div>
        </div>
    </main-layout>
</template>

<script>
    // import VLink from '../components/VLink.vue'
    import MainLayout from './layout/Main.vue'
    export default {
        name: "NotFound",
        components: {
            MainLayout
        }
    }
</script>

<style scoped>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
</style>